/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EmissionValuesResponse as ApiEmissionValuesResponse } from '../models/api/emission-values-response';
import { ListEmissionValuesResponse as ApiListEmissionValuesResponse } from '../models/api/list-emission-values-response';
import { createEmissionValue } from '../fn/emission-values/create-emission-value';
import { CreateEmissionValue$Params } from '../fn/emission-values/create-emission-value';
import { deleteEmissionValue } from '../fn/emission-values/delete-emission-value';
import { DeleteEmissionValue$Params } from '../fn/emission-values/delete-emission-value';
import { listEmissionValues } from '../fn/emission-values/list-emission-values';
import { ListEmissionValues$Params } from '../fn/emission-values/list-emission-values';
import { updateEmissionValue } from '../fn/emission-values/update-emission-value';
import { UpdateEmissionValue$Params } from '../fn/emission-values/update-emission-value';

@Injectable({ providedIn: 'root' })
export class EmissionValuesService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEmissionValues()` */
  static readonly ListEmissionValuesPath = '/v1/boards/{boardId}/emission-values';

  /**
   * List emission values.
   *
   * List all emission values for a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEmissionValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEmissionValues$Response(
    params: ListEmissionValues$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListEmissionValuesResponse>> {
    return listEmissionValues(this.http, this.rootUrl, params, context);
  }

  /**
   * List emission values.
   *
   * List all emission values for a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEmissionValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEmissionValues(
    params: ListEmissionValues$Params,
    context?: HttpContext
  ): Observable<ApiListEmissionValuesResponse> {
    return this.listEmissionValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListEmissionValuesResponse>): ApiListEmissionValuesResponse => r.body)
    );
  }

  /** Path part for operation `createEmissionValue()` */
  static readonly CreateEmissionValuePath = '/v1/boards/{boardId}/emission-values';

  /**
   * Create emission value.
   *
   * Create emission value for a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEmissionValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEmissionValue$Response(
    params: CreateEmissionValue$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiEmissionValuesResponse>> {
    return createEmissionValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Create emission value.
   *
   * Create emission value for a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEmissionValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEmissionValue(
    params: CreateEmissionValue$Params,
    context?: HttpContext
  ): Observable<ApiEmissionValuesResponse> {
    return this.createEmissionValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiEmissionValuesResponse>): ApiEmissionValuesResponse => r.body)
    );
  }

  /** Path part for operation `deleteEmissionValue()` */
  static readonly DeleteEmissionValuePath = '/v1/boards/{boardId}/emission-values/{id}';

  /**
   * Delete emission value.
   *
   * Delete emission value for a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEmissionValue()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEmissionValue$Response(
    params: DeleteEmissionValue$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteEmissionValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete emission value.
   *
   * Delete emission value for a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEmissionValue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEmissionValue(params: DeleteEmissionValue$Params, context?: HttpContext): Observable<string> {
    return this.deleteEmissionValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateEmissionValue()` */
  static readonly UpdateEmissionValuePath = '/v1/boards/{boardId}/emission-values/{id}';

  /**
   * Update emission value.
   *
   * Update emission value for a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEmissionValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEmissionValue$Response(
    params: UpdateEmissionValue$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateEmissionValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Update emission value.
   *
   * Update emission value for a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEmissionValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEmissionValue(params: UpdateEmissionValue$Params, context?: HttpContext): Observable<string> {
    return this.updateEmissionValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }
}
